import { dataKeyCommand } from 'dls-icons-data'
import { createIcon } from '../common'

const IconKeyCommand = /*#__PURE__*/createIcon(dataKeyCommand)
export default IconKeyCommand
